<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.name"
        placeholder="流程名称"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="handleFilter"
      />
      <el-select v-model="listQuery.type" placeholder="流程类型" class="filter-item" style="width: 150px;" clearable>
        <el-option label="审批流程" value="approval" />
        <el-option label="业务流程" value="business" />
      </el-select>
      <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        搜索
      </el-button>
      <el-button
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-plus"
        @click="handleCreate"
      >
        新建流程
      </el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="流程编码" width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column label="流程名称" min-width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="流程标题" min-width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="流程类型" width="120" align="center">
        <template slot-scope="{row}">
          <el-tag :type="row.type === 'approval' ? 'primary' : 'success'">
            {{ row.type === 'approval' ? '审批流程' : '业务流程' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="当前版本" width="100" align="center">
        <template slot-scope="{row}">
          <span>V{{ row.version || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="{row}">
          <el-tag :type="row.canUse ? 'success' : 'info'">
            {{ row.canUse ? '已启用' : '未启用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="160" align="center">
        <template slot-scope="{row}">
          <span>{{ formatTime(row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200" fixed="right">
        <template slot-scope="{row}">
          <el-button type="primary" size="mini" @click="handleVersions(row)">
            版本管理
          </el-button>
          <el-dropdown trigger="click" style="margin-left: 10px;" @command="command => handleAction(command, row)">
            <el-button size="mini">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit">编辑</el-dropdown-item>
              <el-dropdown-item v-if="!row.canUse" command="enable">启用</el-dropdown-item>
              <el-dropdown-item v-if="row.canUse" command="disable">停用</el-dropdown-item>
              <el-dropdown-item divided command="delete">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.size"
      @pagination="getList"
    />

    <!-- 新建/编辑流程对话框 -->
    <el-dialog :title="dialogStatus === 'create' ? '新建流程' : '编辑流程'" :visible.sync="dialogFormVisible" width="500px">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="100px">
        <el-form-item label="流程编码" prop="code">
          <el-input v-model="temp.code" placeholder="请输入流程编码（英文）" :disabled="dialogStatus === 'update'" />
        </el-form-item>
        <el-form-item label="流程名称" prop="name">
          <el-input v-model="temp.name" placeholder="请输入流程名称" />
        </el-form-item>
        <el-form-item label="流程标题" prop="title">
          <el-input v-model="temp.title" placeholder="请输入流程标题（显示名）" />
        </el-form-item>
        <el-form-item label="流程类型" prop="type">
          <el-select v-model="temp.type" placeholder="请选择流程类型" style="width: 100%;">
            <el-option label="审批流程" value="approval" />
            <el-option label="业务流程" value="business" />
          </el-select>
        </el-form-item>
        <el-form-item label="操作密码" prop="operationPassword">
          <el-input v-model="temp.operationPassword" type="password" placeholder="请输入操作密码" show-password />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogStatus === 'create' ? createData() : updateData()">确认</el-button>
      </div>
    </el-dialog>

    <!-- 版本管理对话框 -->
    <el-dialog title="版本管理" :visible.sync="versionDialogVisible" width="800px">
      <div style="margin-bottom: 12px; display: flex; justify-content: space-between; align-items: center;">
        <span style="font-size: 13px; color: #909399;">
          当前使用版本：<el-tag size="small" type="success">V{{ currentFlowDefVersion || 0 }}</el-tag>
        </span>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleCreateNewVersion">新建版本</el-button>
      </div>
      <el-table :data="versionList" border :row-class-name="versionRowClassName">
        <el-table-column label="版本号" width="120" align="center">
          <template slot-scope="{row}">
            <span>V{{ row.version }}</span>
            <el-tag v-if="row.version === currentFlowDefVersion" size="mini" type="success" style="margin-left: 4px;">当前</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="{row}">
            <span>{{ formatTime(row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" size="small" icon="el-icon-edit" @click="handleEditVersion(row)">编辑此版本</el-button>
            <el-button type="text" size="small" icon="el-icon-document-copy" @click="handleCopyVersion(row)">复制为新版本</el-button>
            <el-button
              v-if="row.version !== currentFlowDefVersion"
              type="text"
              size="small"
              icon="el-icon-check"
              style="color: #67c23a;"
              @click="handleUseVersion(row)"
            >使用此版本</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getFlowDefList, createFlowDef, updateFlowDef, deleteFlowDef, getFlowDefLogList, useFlowDefVersion } from '../../api/workflow'
import waves from '../../directive/waves'
import Pagination from '../../components/Pagination'

export default {
  name: 'FlowDef',
  components: { Pagination },
  directives: { waves },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        name: '',
        type: ''
      },
      temp: {
        id: undefined,
        code: '',
        name: '',
        title: '',
        type: 'approval',
        operationPassword: ''
      },
      dialogFormVisible: false,
      dialogStatus: '',
      rules: {
        code: [{ required: true, message: '流程编码不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '流程名称不能为空', trigger: 'blur' }],
        title: [{ required: true, message: '流程标题不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '请选择流程类型', trigger: 'change' }],
        operationPassword: [{ required: true, message: '请输入操作密码', trigger: 'blur' }]
      },
      versionDialogVisible: false,
      versionList: [],
      currentFlowDefId: null,
      currentFlowDefVersion: 0
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      const params = {
        page: this.listQuery.page - 1,
        size: this.listQuery.size
      }
      if (this.listQuery.name) {
        params.name = this.listQuery.name
      }
      if (this.listQuery.type) {
        params.type = this.listQuery.type
      }
      getFlowDefList(params).then(response => {
        this.list = response.data.content || []
        this.total = response.data.totalElements || 0
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        code: '',
        name: '',
        title: '',
        type: 'approval',
        operationPassword: ''
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const data = {
            ...this.temp,
            createTime: Date.now(),
            canUse: false,
            deleted: false,
            version: 0
          }
          createFlowDef(data, this.temp.operationPassword).then(() => {
            this.dialogFormVisible = false
            this.getList()
            this.$message.success('创建成功')
          })
        }
      })
    },
    handleUpdate(row) {
      this.temp = { ...row, operationPassword: '' }
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          updateFlowDef(this.temp, this.temp.operationPassword).then(() => {
            this.dialogFormVisible = false
            this.getList()
            this.$message.success('更新成功')
          })
        }
      })
    },
    handleAction(command, row) {
      switch (command) {
        case 'edit':
          this.handleUpdate(row)
          break
        case 'enable':
          this.handleToggleStatus(row, true)
          break
        case 'disable':
          this.handleToggleStatus(row, false)
          break
        case 'delete':
          this.handleDelete(row)
          break
      }
    },
    handleVersions(row) {
      this.currentFlowDefId = row.id
      this.currentFlowDefVersion = row.version || 0
      this.versionList = []
      this.versionDialogVisible = true
      getFlowDefLogList(row.id).then(response => {
        this.versionList = response.data || []
      })
    },
    versionRowClassName({ row }) {
      return row.version === this.currentFlowDefVersion ? 'current-version-row' : ''
    },
    handleEditVersion(row) {
      // 编辑此版本：进入设计器，保存后原地更新，不产生新版本
      this.versionDialogVisible = false
      this.$router.push({
        path: '/workflow/designer',
        query: { id: this.currentFlowDefId, logId: row.id, mode: 'edit' }
      })
    },
    handleCopyVersion(row) {
      // 复制此版本：进入设计器，保存后新增版本，不自动应用
      this.versionDialogVisible = false
      this.$router.push({
        path: '/workflow/designer',
        query: { id: this.currentFlowDefId, logId: row.id, mode: 'copy' }
      })
    },
    handleCreateNewVersion() {
      // 新建空白版本：进入设计器，保存后新增版本
      this.versionDialogVisible = false
      this.$router.push({
        path: '/workflow/designer',
        query: { id: this.currentFlowDefId, mode: 'copy' }
      })
    },
    handleUseVersion(row) {
      this.$prompt(`确定要将当前使用版本切换为 V${row.version} 吗？请输入操作密码`, '安全验证', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password',
        inputPlaceholder: '操作密码',
        inputValidator: (val) => !!val || '请输入操作密码'
      }).then(({ value }) => {
        useFlowDefVersion(this.currentFlowDefId, row.version, value).then(() => {
          this.currentFlowDefVersion = row.version
          this.getList()
          this.$message.success('版本切换成功，当前使用 V' + row.version)
        })
      })
    },
    handleToggleStatus(row, canUse) {
      const text = canUse ? '启用' : '停用'
      this.$prompt(`确定要${text}该流程吗？请输入操作密码`, '安全验证', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password',
        inputPlaceholder: '操作密码',
        inputValidator: (val) => !!val || '请输入操作密码'
      }).then(({ value }) => {
        updateFlowDef({ ...row, canUse }, value).then(() => {
          this.getList()
          this.$message.success(`${text}成功`)
        })
      })
    },
    handleDelete(row) {
      this.$prompt('确定要删除该流程吗？删除后不可恢复！请输入操作密码', '安全验证', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password',
        inputPlaceholder: '操作密码',
        inputValidator: (val) => !!val || '请输入操作密码'
      }).then(({ value }) => {
        deleteFlowDef(row.id, value).then(() => {
          this.getList()
          this.$message.success('删除成功')
        })
      })
    },
    askOperationPassword() {
      return this.$prompt('请输入操作密码', '安全验证', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password',
        inputPlaceholder: '操作密码',
        inputValidator: (val) => !!val || '请输入操作密码'
      }).then(({ value }) => value)
    },
    formatTime(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp)
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const min = String(date.getMinutes()).padStart(2, '0')
      return `${y}-${m}-${d} ${h}:${min}`
    }
  }
}
</script>

<style scoped>
.filter-container {
  padding-bottom: 10px;
}
.filter-item {
  margin-right: 10px;
}
</style>
<style>
.current-version-row {
  background-color: #f0f9eb !important;
}
</style>
